import { InjectionToken } from '@angular/core';
import { AuthenticationModuleSettings } from './authentication-settings';

export let AUTHENTICATION_SETTINGS_TOKEN = new InjectionToken<AuthenticationModuleSettings>('authenticationSettings');
